import { Pipe, PipeTransform } from '@angular/core';
import { NzIdWarningCodeType } from './model/nz-id-warning-code-type';

@Pipe({
    name: 'nzIdWarningCodeReadable',
    standalone: true,
})
export class NzIdWarningCodeReadablePipe implements PipeTransform {

    transform(warningCode: string): any {
        const nzIdWarningCodeType = NzIdWarningCodeType[warningCode as keyof typeof NzIdWarningCodeType];
        switch (nzIdWarningCodeType.valueOf()) {
            case NzIdWarningCodeType.NEW_ID_OVERWRITE_INACTIVE_NZO_WITH_ZERO_EA:
                return '(Netzzuordnung-ID neu) bereits als deaktivierte Netzzuordnung gekennzeichnet. ' +
                    'Die deaktivierte Netzzuordnung wird aus der Liste der deaktivierten Netzzuordnungen gelöscht und die als Netzzuordnung-ID alt ' +
                    'angegebene Netzzuordnung erhält diese ID.';
            default:
                console.error('Unknown warning code: ' + warningCode);
                return 'Unbekannter Warnungstype. Bitte kontaktieren Sie den Support.';
        }
    }
}
